import { Validator } from "../validator"

export enum UnitNumberError {
    BLANK = `address_error`,
}

const REGEX = /^[a-zA-Z0-9#-]+$/i
const MAX_LENGTH = 5
class UnitNumberValidator implements Validator<string, UnitNumberError> {
    validate(entry: string): UnitNumberError | undefined {
        if (entry === `` || entry.length > MAX_LENGTH || !REGEX.test(entry)) {
            return UnitNumberError.BLANK
        }
    }
}

export { UnitNumberValidator }